module.exports = __webpack_public_path__ + "static/media/IndicaDomCF.ac0401ec.png";